module.exports = __webpack_public_path__ + "static/media/mountain-meditator-400x253.b70c9e7f.jpg";